import axios from "axios";
import { toast } from "react-toastify";
import { push } from "connected-react-router";

export const LOG_GET_ARTICLES_REQUEST = "LOG_GET_CATADVS_REQUEST";
export const LOG_GET_ARTICLES_SUCCESS = "LOG_GET_ARTICLES_SUCCESS";
export const LOG_GET_ARTICLES_FAIL = "LOG_GET_ARTICLES_FAIL";
export const getArticles = params => dispatch => {
  dispatch({
    type: LOG_GET_ARTICLES_REQUEST
  });
  axios
    .request({
      url: "dashboard/change_logs",
      params: params,
      method: "GET"
    })
    .then(({ data }) => {
      if (data.success) {
        dispatch({
          type: LOG_GET_ARTICLES_SUCCESS,
          msg: data.message,
          data: data.data
        });
      } else {
        dispatch({
          type: LOG_GET_ARTICLES_FAIL,
          msg: data.message,
          errors: data.errors ? data.errors : {}
        });
        // toast.warn(data.message);
      }
    });
};

export const LOG_GET_CATEGORIES_REQUEST = "LOG_GET_CATEGORIES_REQUEST";
export const LOG_GET_CATEGORIES_SUCCESS = "LOG_GET_CATEGORIES_SUCCESS";
export const LOG_GET_CATEGORIES_FAIL = "LOG_GET_CATEGORIES_FAIL";
export const getCategories = params => dispatch => {
  dispatch({
    type: LOG_GET_CATEGORIES_REQUEST
  });
  axios
    .request({
      url: "categories",
      params: {},
      method: "GET"
    })
    .then(({ data }) => {
      if (data.success) {
        dispatch({
          type: LOG_GET_CATEGORIES_SUCCESS,
          msg: data.message,
          data: data.data
        });
      } else {
        dispatch({
          type: LOG_GET_CATEGORIES_FAIL,
          msg: data.message,
          errors: data.errors ? data.errors : {}
        });
        // toast.warn(data.message);
      }
    });
};
